module.exports = __webpack_public_path__ + "static/media/TRITON.6dc393e1.jpg";